import { render, staticRenderFns } from "./PlaylistTeacherThumbnail.vue?vue&type=template&id=576c5a65&scoped=true&"
import script from "./PlaylistTeacherThumbnail.vue?vue&type=script&lang=ts&"
export * from "./PlaylistTeacherThumbnail.vue?vue&type=script&lang=ts&"
import style0 from "./PlaylistTeacherThumbnail.vue?vue&type=style&index=0&id=576c5a65&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576c5a65",
  null
  
)

export default component.exports